var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chat.typeName === 'one-to-one' && _vm.receiver)?_c('Avatar',{attrs:{"user":_vm.receiver,"size":_vm.size,"isShowOnline":_vm.isShowOnline}}):(_vm.chat.typeName === 'group')?_c('AvatarGroup',{attrs:{"chat":_vm.chat,"size":_vm.size}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }